module.exports = __webpack_public_path__ + "e060bbda65f5f4af91d20a9def3cef84.woff2";